module.exports = __webpack_public_path__ + "assets/img/square.77c4fc65.svg";